












































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ChargeDetailVue from "./ChargeDetail.vue";
import ChargeThrowVue from "./ChargeThrow.vue";
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "charge-detail": ChargeDetailVue,
        "charge-throw": ChargeThrowVue
    }
})
export default class ChargeRecord extends Vue {
    @Prop({ type: Object })
    bookData?: Charge.Charge;

    recordData: Charge.ChargeRecord[] = [];
    delIndex: number = 0;
    currentPage: number = 1;
    pageSize: number = 15;
    tableData: Charge.ChargeRecord | null = null;
    totalElements: number = 0;

    mounted() {
        this.fetchData();
    }
    // 获取表格数据
    fetchData() {
        if (this.bookData) {
            Vue.axios
                .post(
                    `charge/history?page=${this.currentPage - 1}&size=${
                        this.pageSize
                    }`,
                    {
                        id: this.bookData.id
                    }
                )
                .then(res => {
                    this.recordData = res.data.content;
                    this.totalElements = res.data.totalElements;
                    for (let i = 0; i < this.recordData.length; i++) {
                        if (this.recordData[i].isDel == 0) {
                            this.delIndex = i;
                            break;
                        }
                    }
                });
        }
    }

    // 分页
    handleCurrentChange(val: any) {
        this.currentPage = val;
        this.fetchData();
    }

    // 打开详情
    showDetail: boolean = false;
    openDetail(data: Charge.ChargeRecord) {
        // data.bookName = this.bookData.bookName;
        this.tableData = data;
        this.showDetail = true;
    }
    closeDetail() {
        this.showDetail = false;
    }
    detailSuccess() {
        this.showDetail = false;
    }
    // 废除
    showThrow: boolean = false;
    openThrow(data: Charge.ChargeRecord) {
        this.tableData = data;
        this.showThrow = true;
    }
    closeThrow() {
        this.showThrow = false;
    }
    throwSuccess() {
        this.fetchData();
        this.showThrow = false;
    }
}
